export default "/build/images/logo-arabic-600x175.png?b1037334d0b7bc87b8d074f59c290767";